import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../../api/request';
import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import { PaginationQueryDto } from '../../../../../../types/paginationRequestType';
import { getDraftSurveys } from '../../../api';
import { SurveyDraftListResponseType } from '../../../types/SurveyDraft';

export const ITEMS_PER_PAGE_DEFAULT = 10;

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  PaginationQueryDto,
  SurveyDraftListResponseType,
  AxiosResultDefaultError
>();

export function useSurveyListLoader() {
  return useFetch();
}

export const SurveyListLoaderConsumer = FetchConsumer;

export default function SurveyListLoader({ children }: BaseLoaderProps) {
  const request = useCallback(async (query) => {
    return getDraftSurveys({
      ...query,
      page: query.page - 1,
      items_per_page: ITEMS_PER_PAGE_DEFAULT,
    });
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ page: 1 }}
      fetchImmediately
    >
      {children}
    </FetchProvider>
  );
}
